import { render, staticRenderFns } from "./StudentSubscription.vue?vue&type=template&id=ef69b8fe&"
import script from "./StudentSubscription.vue?vue&type=script&lang=js&"
export * from "./StudentSubscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports